import React, { Component } from 'react';
import BackgroundLoad from './BackgroundLoad';
import Transitioner from '../utils/Transitioner';
// import LoadingBar from './LoadingBar';
import style from './SlideLoader.module.scss';

class SlideLoader extends Component {
  state = {
    current: null,
    complete: false,
    started: false,
  };
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleComplete = () => {
    this.setState({ current: null, complete: true }, () => {
      setTimeout(() => {
        if (this.props.onComplete) {
          this.props.onComplete();
        }
      }, 750);
    });
  };

  nextSlideTimeout = () => {
    if (this.state.current < this.props.slides.length - 1) {
      this.timeout = setTimeout(() => {
        this.setState(
          { current: this.state.current + 1 },
          this.nextSlideTimeout
        );
      }, this.props.slideTime[this.state.current]);
    } else {
      this.timeout = setTimeout(
        this.handleComplete,
        this.props.slideTime[this.state.current]
      );
    }
  };
  start = () => {
    this.setState({ current: 0, started: true });
    this.nextSlideTimeout();
  };

  render() {
    return (
      <React.Fragment>
        <div className={style.slideLoader}>
          <div ref={this.props.getRef} className={style.imgFrame}>
            <BackgroundLoad
              src={this.props.bk.src}
              opacity={this.props.bk.opacity}
              onLoadComplete={this.start}
            />
          </div>
        </div>
        <div
          className={style.correctDistortionWrapper}
          ref={this.props.getSlidesRef}
        >
          {this.props.slides.map((slide, i) => (
            <Transitioner
              isActive={this.state.current === i}
              timeout={1500}
              classNames="slideUp"
              key={`slide${i}`}
            >
              <div className={style.slideWrap}>{slide}</div>
            </Transitioner>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default SlideLoader;



// WEBPACK FOOTER //
// ./src/components/ui/SlideLoader.js